// Pixi's automatic cutoff is only 200 vertices. Authored scenery often sits
// just above it, splitting an otherwise shared sprite/graphics batch per shape.
// Bound the work here so huge user-authored paths keep Pixi's separate draws.
const MAX_BATCH_VERTICES = 2048;

export const updateGraphicBatchMode = graphics => {
    const context = graphics.context;
    let vertices = 0;
    for (const instruction of context.instructions) {
        if (instruction.action !== 'fill' && instruction.action !== 'stroke') {
            context.batchMode = 'auto';
            return;
        }
        const {path, hole} = instruction.data;
        // Let Pixi handle holes and non-polygon primitives automatically.
        if (hole) {
            context.batchMode = 'auto';
            return;
        }
        for (const {shape} of path.shapePath.shapePrimitives) {
            if (shape.type !== 'polygon') {
                context.batchMode = 'auto';
                return;
            }
            // Include a conservative allowance for stroke joins/caps. Accessing
            // shapePath flattens curves once; Pixi reuses that path when drawing.
            vertices += shape.points.length / 2 * (instruction.action === 'stroke' ? 8 : 1);
            if (vertices > MAX_BATCH_VERTICES) {
                context.batchMode = 'auto';
                return;
            }
        }
    }
    context.batchMode = 'batch';
};
